import React, { useState } from "react";
import { FormGroup, FormRow, Row, Textarea } from "styles/forms/main";
import { getAllGovernorates, getAllSuppliers, useMapDataToUi } from "hooks/mapDataToOptions";
import { deleteSingleAttachment } from "modules/shared/api";
import { getUserRoles } from "modules/auth/slice";
import { useSelector } from "react-redux";
import {
    AccordionComponent,
    Input,
    SelectWithSearch,
    UploadAttachments,
    RejectionReason,
    VerifyComponent,
} from "components";
import EditHandler from "./EditHandler";
import { LICENSE } from "../staticData";
import { TRUCK_TYPE } from "modules/suppliers/staticData";
function WorkingInfo({
    driverData,
    errors,
    handleDataFroSubmit,
    isEditable,
    isEidtSection,
    uploadedAttachments,
    setAttachments,
    objections,
    isAuthorizedToCreate,
    isQARole,
    handleObjections,
}) {
    const allGovernorates = useMapDataToUi("governorates");
    const suppliers = useMapDataToUi("suppliers");
    const [isOnEdit, setIsOnEdit] = useState(false);
    const [objection, setObjections] = useState({});
    const getCurrentUserRoles = useSelector(getUserRoles());
    const isSupplierPartner = getCurrentUserRoles?.includes("supplier_partner_account_manager");
    const getCurrentUserRole = useSelector(getUserRoles()).filter((role) => role === "reviewer");
    const handleDeleteSingleAttachment = async (id) => {
        await deleteSingleAttachment(id)
            .then(() => {
                setAttachments(uploadedAttachments.filter((item) => item?.id !== id));
            })
            .catch(() => {});
    };
    const handleDeleteAllAttachment = async (attachments) => {
        await Promise.all(
            // eslint-disable-next-line array-callback-return
            attachments.map((attachment) => {
                deleteSingleAttachment(attachment?.id);
            })
        ).then(() => {
            setAttachments([]);
        });
    };

    const renderObjection = (objectionName) => {
        if (objections && objections[objectionName] && isAuthorizedToCreate) {
            return <RejectionReason content={objections[objectionName]} />;
        }
        return null;
    };

    const openObjectionhandler = (fieldName) => {
        setObjections({
            ...objection,
            [fieldName]: {
                haveobjection: true,
                verified: false,
            },
        });
    };
    const handleVerify = (fieldName, item, section, category) => {
        setObjections({
            ...objection,
            [fieldName]: {
                verified: true,
                haveobjection: false,
            },
        });
        handleObjections(null, item, section, category, true);
    };
    return (
        <AccordionComponent
            title="working Info"
            defaultExpanded
            extraAction={
                isEidtSection && (
                    <EditHandler
                        isOnEdit={isOnEdit}
                        setIsOnEdit={setIsOnEdit}
                    />
                )
            }
            body={
                <>
                    <FormRow>
                        <FormGroup>
                            <Row>
                                <SelectWithSearch
                                    name="workingGovernorates"
                                    errorMsg={errors?.workingGovernorates}
                                    error={errors?.workingGovernorates}
                                    options={allGovernorates}
                                    handleFilter={(filter) => getAllGovernorates(filter)}
                                    handleChange={(value) =>
                                        handleDataFroSubmit(value, "workingGovernorates")
                                    }
                                    value={driverData?.workingGovernorates}
                                    label="Working Governorate"
                                    isMulti
                                    required
                                    placeholder="Select"
                                    isEditable={isEditable || isOnEdit}
                                />
                                {renderObjection("Working Governate")}
                                {getCurrentUserRole[0] === "reviewer" && isQARole && (
                                    <VerifyComponent
                                        objectionHandler={() =>
                                            openObjectionhandler("workingGovernorates")
                                        }
                                        handleVerify={() =>
                                            handleVerify(
                                                "workingGovernorates",
                                                "Working Governate",
                                                "Working Info - Driver",
                                                "driver_profile"
                                            )
                                        }
                                        verifed={
                                            objection?.workingGovernorates?.verified
                                                ? objection?.workingGovernorates?.verified
                                                : false
                                        }
                                        objection={
                                            objection?.workingGovernorates?.haveobjection
                                                ? objection?.workingGovernorates?.haveobjection
                                                : false
                                        }
                                    />
                                )}
                            </Row>
                            {objection?.workingGovernorates?.haveobjection && (
                                <Textarea
                                    autoFocus
                                    required
                                    onBlur={(e) =>
                                        handleObjections(
                                            e,
                                            "Working Governate",
                                            "Working Info - Driver",
                                            "driver_profile",
                                            false
                                        )
                                    }
                                />
                            )}
                        </FormGroup>
                        <FormGroup>
                            <SelectWithSearch
                                isEditable={isEditable || isOnEdit}
                                isMulti
                                label="Preferred truck type"
                                name="truckTypes"
                                options={TRUCK_TYPE}
                                handleChange={(value) => handleDataFroSubmit(value, "truckTypes")}
                                value={driverData?.truckTypes}
                                placeholder="Select"
                                required
                                errorMessage={errors?.truckTypes && errors?.truckTypes}
                            />
                        </FormGroup>
                    </FormRow>
                    <FormRow>
                        <FormGroup>
                            <Row>
                                <SelectWithSearch
                                    options={suppliers}
                                    name="supplier"
                                    errorMsg={errors?.supplier}
                                    error={errors?.supplier}
                                    handleFilter={(filter) => getAllSuppliers(filter)}
                                    handleChange={(value) => handleDataFroSubmit(value, "supplier")}
                                    value={driverData?.supplier}
                                    label="Supplier"
                                    isMulti={isSupplierPartner}
                                    required
                                    isEditable={isEditable || isOnEdit}
                                />
                                {renderObjection("Supplier")}
                                {getCurrentUserRole[0] === "reviewer" && isQARole && (
                                    <VerifyComponent
                                        objectionHandler={() => openObjectionhandler("supplier")}
                                        handleVerify={() =>
                                            handleVerify(
                                                "supplier",
                                                "Supplier",
                                                "Working Info - Driver",
                                                "driver_profile"
                                            )
                                        }
                                        verifed={
                                            objection?.supplier?.verified
                                                ? objection?.supplier?.verified
                                                : false
                                        }
                                        objection={
                                            objection?.supplier?.haveobjection
                                                ? objection?.supplier?.haveobjection
                                                : false
                                        }
                                    />
                                )}
                            </Row>
                            {objection?.supplier?.haveobjection && (
                                <Textarea
                                    required
                                    autoFocus
                                    onBlur={(e) =>
                                        handleObjections(
                                            e,
                                            "Supplier",
                                            "Working Info - Driver",
                                            "driver_profile",
                                            false
                                        )
                                    }
                                />
                            )}
                        </FormGroup>
                        <FormGroup>
                            <Row>
                                <Input
                                    type="date"
                                    name="licenseExpiryDate"
                                    min={new Date().toISOString().split("T")[0]}
                                    error={errors?.licenseExpiryDate}
                                    isEditable={isEditable || isOnEdit}
                                    required
                                    placeholder="DD/MM/YYY"
                                    label="Driving License Expiration Date"
                                    value={driverData?.licenseExpiryDate}
                                    onChange={(e) => handleDataFroSubmit(e)}
                                />
                                {renderObjection("Driving License Expiration")}
                                {getCurrentUserRole[0] === "reviewer" && isQARole && (
                                    <VerifyComponent
                                        objectionHandler={() =>
                                            openObjectionhandler("licenseExpiryDate")
                                        }
                                        handleVerify={() =>
                                            handleVerify(
                                                "licenseExpiryDate",
                                                "Driving License Expiration",
                                                "Working Info - Driver",
                                                "driver_profile"
                                            )
                                        }
                                        verifed={
                                            objection?.licenseExpiryDate?.verified
                                                ? objection?.licenseExpiryDate?.verified
                                                : false
                                        }
                                        objection={
                                            objection?.licenseExpiryDate?.haveobjection
                                                ? objection?.licenseExpiryDate?.haveobjection
                                                : false
                                        }
                                    />
                                )}
                            </Row>
                            {objection?.licenseExpiryDate?.haveobjection && (
                                <Textarea
                                    required
                                    autoFocus
                                    onBlur={(e) =>
                                        handleObjections(
                                            e,
                                            "Driving License Expiration",
                                            "Working Info - Driver",
                                            "driver_profile",
                                            false
                                        )
                                    }
                                />
                            )}
                        </FormGroup>
                        <FormGroup>
                            <Row>
                                <SelectWithSearch
                                    name="drivingLicenseType "
                                    errorMsg={errors?.drivingLicenseType}
                                    error={errors?.drivingLicenseType}
                                    options={LICENSE}
                                    handleChange={(value) =>
                                        handleDataFroSubmit(value, "drivingLicenseType")
                                    }
                                    value={driverData?.drivingLicenseType}
                                    label="Driving license type "
                                    required
                                    placeholder="Select"
                                    isEditable={isEditable || isOnEdit}
                                />
                                {renderObjection("Driving License Type")}
                                {getCurrentUserRole[0] === "reviewer" && isQARole && (
                                    <VerifyComponent
                                        objectionHandler={() =>
                                            openObjectionhandler("drivingLicenseType")
                                        }
                                        handleVerify={() =>
                                            handleVerify(
                                                "drivingLicenseType",
                                                "Driving License Type",
                                                "Working Info - Driver",
                                                "driver_profile"
                                            )
                                        }
                                        verifed={
                                            objection?.drivingLicenseType?.verified
                                                ? objection?.drivingLicenseType?.verified
                                                : false
                                        }
                                        objection={
                                            objection?.drivingLicenseType?.haveobjection
                                                ? objection?.drivingLicenseType?.haveobjection
                                                : false
                                        }
                                    />
                                )}
                            </Row>
                            {objection?.drivingLicenseType?.haveobjection && (
                                <Textarea
                                    required
                                    autoFocus
                                    onBlur={(e) =>
                                        handleObjections(
                                            e,
                                            "Driving License Type",
                                            "Working Info - Driver",
                                            "driver_profile",
                                            false
                                        )
                                    }
                                />
                            )}
                        </FormGroup>
                    </FormRow>
                    <FormRow>
                        <FormGroup>
                            <Row>
                                <UploadAttachments
                                    isEditable={isEditable || isOnEdit}
                                    errorMessage={errors?.driverLicense}
                                    name="driverLicense"
                                    maxLength={1}
                                    required
                                    onFilesChange={(e) => handleDataFroSubmit(e, "driverLicense")}
                                    label="Driving License Photo"
                                    onDeleteAllAttachements={() =>
                                        handleDeleteAllAttachment(
                                            uploadedAttachments?.filter(
                                                (item) => item?.documentType === "driver_license"
                                            )
                                        )
                                    }
                                    uploadedAttachments={uploadedAttachments?.filter(
                                        (item) => item?.documentType === "driver_license"
                                    )}
                                    onDeleteUploadedItem={handleDeleteSingleAttachment}
                                    showConfirmation
                                />
                                {renderObjection("Driving License Photo")}
                                {getCurrentUserRole[0] === "reviewer" &&
                                    uploadedAttachments?.filter(
                                        (item) => item?.documentType === "driver_license"
                                    )?.length > 0 &&
                                    isQARole && (
                                        <VerifyComponent
                                            objectionHandler={() =>
                                                openObjectionhandler("driverLicense")
                                            }
                                            handleVerify={() =>
                                                handleVerify(
                                                    "driverLicense",
                                                    "Driving License Photo",
                                                    "Working Info - Driver",
                                                    "driver_profile"
                                                )
                                            }
                                            verifed={
                                                objection?.driverLicense?.verified
                                                    ? objection?.driverLicense?.verified
                                                    : false
                                            }
                                            objection={
                                                objection?.driverLicense?.haveobjection
                                                    ? objection?.driverLicense?.haveobjection
                                                    : false
                                            }
                                        />
                                    )}
                            </Row>
                            {objection?.driverLicense?.haveobjection && (
                                <Textarea
                                    required
                                    autoFocus
                                    onBlur={(e) =>
                                        handleObjections(
                                            e,
                                            "Driving License Photo",
                                            "Working Info - Driver",
                                            "driver_profile",
                                            false
                                        )
                                    }
                                />
                            )}
                        </FormGroup>
                    </FormRow>
                </>
            }
        />
    );
}

export default WorkingInfo;
